import { isProd } from './../../commons/utils';

const CONSENT_API_KEY = isProd ? '02d83a98-b875-4588-b694-ceff0e0dd87c' : 'b542bb45-8028-4268-b5d1-fe25ce7f9fdf';
const COUNTRY = cube.env.country;

let lastInput = null;
let lastAction = null;
let historyIsVisible = false;


// Toggle Consent Modal
function showModal() {
  cube.$id('consents-modal').checked = true;
  cube.$id('consents-modal-button').on('click', lastAction);
}

function hideModal() {
  cube.$id('consents-modal').checked = false;
  cube.$id('consents-modal-button').off('click', lastAction);
}


// Ajax call to register subscrition
function setSubscription(input, data) {
  if(input.closest('article.consent')) {
    input.closest('article.consent').classList.add('consent--loading');
  }
  if(cube.env.country === 'CN'){
    data.optinType = 'SPORT';
    data.id = 10;
    cube.ajax
      .post('/rest/model/atg/userprofiling/ProfileActor/setUserSubscription', data)
      .onSuccess(updateSuccess)
      .onError(updateError)
      .call();
  }else{
    const newData = {
      consents: {
        channels: [],
        purposes: [
          {
            id: data.optinType,
            enabled: data.value
          }
        ]
      }
    };
    cube.ajax.post('api-proxy/consent_management/external/v1/events', {
      'httpMethod': 'POST',
      'jsonBody': newData,
      'httpHeaders': {'X-Api-Key': CONSENT_API_KEY, 'application_country_code': COUNTRY, 'user_language': COUNTRY}
    })
      .onSuccess(response => {
        updateSuccess(response);
      })
      .onError(error => {
        updateError(error);
      })
      .call();
  }
}


// Update User Subscription
function updateSubscription(e) {
  e.preventDefault();

  const input = e.target;
  const value = input.checked;
  const optinType = input.getAttribute('data-type');
  const { id, customerid: customerId } = input.dataset;

  const doubleOptin = cube.$id('consents').hasAttribute('data-double-optin');

  lastInput = input;
  lastAction = () => setSubscription(lastInput, { customerId, id, optinType, value });

  // If double optin is activated
  if (value && doubleOptin) showModal();
  else                      lastAction();
}


// Reload the cartridge when subscription update is successfull
function updateSuccess({ responseTO: { errors } }) {
  hideModal();

  const afterReloadCartridge = () => {
    if (errors.length) cube.alert.error(errors.map((error) => error.message).join(', '));
    else               cube.alert.success(window.Messages('profile.changesSaved'));
    init();
  };

  cube.cartridge('my-subscriptions')
    .after(afterReloadCartridge)
    .reload(cube.urlParams)
  ;
}


// Display an error and reset modification when subscription update fail
function updateError({ error: { message } }) {
  cube.alert.error(message);
  if (lastInput) lastInput.checked = !lastInput.checked;
}


// Toggle History pannel (if hostory panel is visible, back button hide it)
function toggleHistory(e) {
  e.preventDefault();

  historyIsVisible = !historyIsVisible;

  const header = cube.$id('subscriptions-header');

  // switch title
  const curentText = header.$('.text').innerText;
  const altText = header.dataset.text;
  header.dataset.text = curentText;
  header.$('.text').innerText = altText;

  cube.$id('consents').classList.toggle('dkt-consents--hide');
  cube.$id('consents-history').classList.toggle('dkt-consents-history--hide');

}


// INIT
export function init() {
  if(COUNTRY !== 'CN'){
    displaySubscription();
  }else{
    cube.$id('mysports-RmzeVX4K').classList.add('visible');
  }
  cube.$$('.dkt-toggler input').on('change', updateSubscription);
  cube.$$('.consent__history-link .cta-link').on('click', toggleHistory);
  cube.$id('back-button').on('click', e => { if (historyIsVisible) toggleHistory(e); });
  cube.event.on('modalClose', () => { lastInput.checked = false; });
}

export function displaySubscription(){
  if(!isProd){
    cube.$id('myevents-3pY2nwPp').id = 'events-2z3mUAhV';
    cube.$name('event')[0].setAttribute('data-type', 'events-2z3mUAhV');
    cube.$id('myreviews-fDMg84qt').id = 'reviews-Zp2Mznay';
    cube.$name('opinion')[0].setAttribute('data-type', 'reviews-Zp2Mznay');
    cube.$id('mysports-RmzeVX4K').id = 'mysportc-2hRPjWnq';
    cube.$name('sport')[0].setAttribute('data-type', 'mysportc-2hRPjWnq');

    cube.$id('mysportc-2hRPjWnq').classList.add('visible');
  }
  cube.ajax.post('api-proxy/consent_management/external/v2/metadata/consents', {
    'httpMethod': 'GET',
    'queryParameters': {'country_code': COUNTRY, 'tags': 'communication'},
    'httpHeaders': {'X-Api-Key': CONSENT_API_KEY}
  })
    .onSuccess((response) => {
      const subscriptions = response.responseTO.data.responseBody.consents.purposes;
      if(subscriptions){
        for(let i = 0; i < subscriptions.length; i+=1) {
          const consent = cube.$id(subscriptions[i].id);
          consent.classList.add('visible');
          if(subscriptions[i].default_value){
            cube.$(`#${consent.id} input`).setAttribute('checked', 'checked');
          }
        }
      }
    })
    .onError(updateError)
    .call();

  cube.ajax.post('api-proxy/consent_management/external/v1/user', {
    'httpMethod': 'GET',
    'httpHeaders': {'X-Api-Key': CONSENT_API_KEY }
  })
    .onSuccess((response) => {
      const subscriptions = response.responseTO.data.responseBody.events[0].consents.purposes;
      if(subscriptions){
        for(let i = 0; i < subscriptions.length; i+=1) {
          if(cube.$id(subscriptions[i].id)){
            const consent = cube.$id(subscriptions[i].id);
            consent.classList.add('visible');
            if(subscriptions[i].enabled){
              cube.$(`#${consent.id} input`).setAttribute('checked', 'checked');
            }
          }
        }
      }
    })
    .onError(updateError)
    .call();
}



// WEBPACK FOOTER //
// ./src/customer/account/account-subscriptions.js